// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BusinessSwitcher — the foot of the sidebar. The menu is portalled to
   <body>, outside .rf-app where the --rf-* tokens live, so every token
   carries its own fallback. */

.rf-sidebar-business {
  border-top: 1px solid var(--rf-line);
  padding: 10px 14px 12px;
}
.rf-bsw-eyebrow {
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--rf-muted-2, #a29b8d);
  padding: 0 2px 6px;
}
.rf-bsw-btn {
  width: 100%;
  min-height: 44px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 8px;
  border: 1px solid var(--rf-line);
  border-radius: 9px;
  background: var(--rf-card, #fff);
  cursor: pointer;
  font-family: inherit;
  text-align: left;
  color: var(--rf-ink);
}
.rf-bsw-btn:hover,
.rf-bsw-btn.is-open {
  background: var(--rf-gold-tint);
  border-color: var(--rf-gold-lite);
}
.rf-bsw-btn:focus-visible {
  outline: 2px solid var(--rf-gold-lite);
  outline-offset: 1px;
}
.rf-bsw-mark {
  width: 30px;
  height: 30px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 7px;
  background: #fff;
  border: 1px solid #e2dcd0;
  color: #191714;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.02em;
}
.rf-bsw-mark img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
.rf-bsw-mark.is-small {
  width: 26px;
  height: 26px;
  font-size: 10px;
}
.rf-bsw-text {
  min-width: 0;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  line-height: 1.2;
}
.rf-bsw-name {
  font-size: 12.5px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.rf-bsw-role {
  font-size: 11px;
  color: var(--rf-muted, #8b8477);
}
.rf-bsw-caret {
  flex-shrink: 0;
  font-size: 18px;
  color: var(--rf-muted, #8b8477);
}

/* collapsed rail: the mark alone */
.rf-app.is-collapsed .rf-sidebar-business {
  padding: 10px 8px;
}
.rf-app.is-collapsed .rf-bsw-eyebrow,
.rf-app.is-collapsed .rf-bsw-btn .rf-bsw-text,
.rf-app.is-collapsed .rf-bsw-btn .rf-bsw-caret {
  display: none;
}
.rf-app.is-collapsed .rf-bsw-btn {
  justify-content: center;
  padding: 6px 0;
}

/* ---------------- menu (in <body>) ---------------- */
.rf-bsw-menu {
  position: fixed;
  z-index: 80;
  width: 260px;
  max-width: calc(100vw - 16px);
  max-height: min(420px, calc(100vh - 32px));
  overflow-y: auto;
  padding: 6px;
  background: #fff;
  border: 1px solid #e2dcd0;
  border-radius: 12px;
  box-shadow: 0 14px 40px rgba(40, 34, 22, 0.16);
  font-family: "Instrument Sans", Helvetica, Arial, sans-serif;
  color: #191714;
}
.rf-bsw-menu-head {
  padding: 6px 8px 8px;
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #a29b8d;
}
.rf-bsw-opt {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 7px 8px;
  border: none;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
  font-family: inherit;
  text-align: left;
  color: inherit;
}
.rf-bsw-opt:hover:not(:disabled) {
  background: var(--rf-brand-tint, #f6f0e2);
}
.rf-bsw-opt:disabled {
  cursor: default;
}
.rf-bsw-opt.is-current .rf-bsw-name {
  color: var(--rf-brand, #8c6a2c);
}
.rf-bsw-tick {
  width: 14px;
  flex-shrink: 0;
  font-size: 13px;
  font-weight: 700;
  color: var(--rf-brand, #8c6a2c);
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/business-switcher.css"],"names":[],"mappings":"AAAA;;8BAE8B;;AAE9B;EACE,oCAAoC;EACpC,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,iCAAiC;EACjC,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;AACtB;AACA;;EAEE,+BAA+B;EAC/B,iCAAiC;AACnC;AACA;EACE,sCAAsC;EACtC,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,+BAA+B;AACjC;AACA;EACE,cAAc;EACd,eAAe;EACf,+BAA+B;AACjC;;AAEA,mCAAmC;AACnC;EACE,iBAAiB;AACnB;AACA;;;EAGE,aAAa;AACf;AACA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA,uDAAuD;AACvD;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,0CAA0C;EAC1C,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,4DAA4D;EAC5D,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,eAAe;AACjB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;AACpB","sourcesContent":["/* BusinessSwitcher — the foot of the sidebar. The menu is portalled to\n   <body>, outside .rf-app where the --rf-* tokens live, so every token\n   carries its own fallback. */\n\n.rf-sidebar-business {\n  border-top: 1px solid var(--rf-line);\n  padding: 10px 14px 12px;\n}\n.rf-bsw-eyebrow {\n  font-size: 10.5px;\n  font-weight: 600;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--rf-muted-2, #a29b8d);\n  padding: 0 2px 6px;\n}\n.rf-bsw-btn {\n  width: 100%;\n  min-height: 44px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 6px 8px;\n  border: 1px solid var(--rf-line);\n  border-radius: 9px;\n  background: var(--rf-card, #fff);\n  cursor: pointer;\n  font-family: inherit;\n  text-align: left;\n  color: var(--rf-ink);\n}\n.rf-bsw-btn:hover,\n.rf-bsw-btn.is-open {\n  background: var(--rf-gold-tint);\n  border-color: var(--rf-gold-lite);\n}\n.rf-bsw-btn:focus-visible {\n  outline: 2px solid var(--rf-gold-lite);\n  outline-offset: 1px;\n}\n.rf-bsw-mark {\n  width: 30px;\n  height: 30px;\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  border-radius: 7px;\n  background: #fff;\n  border: 1px solid #e2dcd0;\n  color: #191714;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n}\n.rf-bsw-mark img {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n}\n.rf-bsw-mark.is-small {\n  width: 26px;\n  height: 26px;\n  font-size: 10px;\n}\n.rf-bsw-text {\n  min-width: 0;\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  line-height: 1.2;\n}\n.rf-bsw-name {\n  font-size: 12.5px;\n  font-weight: 600;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.rf-bsw-role {\n  font-size: 11px;\n  color: var(--rf-muted, #8b8477);\n}\n.rf-bsw-caret {\n  flex-shrink: 0;\n  font-size: 18px;\n  color: var(--rf-muted, #8b8477);\n}\n\n/* collapsed rail: the mark alone */\n.rf-app.is-collapsed .rf-sidebar-business {\n  padding: 10px 8px;\n}\n.rf-app.is-collapsed .rf-bsw-eyebrow,\n.rf-app.is-collapsed .rf-bsw-btn .rf-bsw-text,\n.rf-app.is-collapsed .rf-bsw-btn .rf-bsw-caret {\n  display: none;\n}\n.rf-app.is-collapsed .rf-bsw-btn {\n  justify-content: center;\n  padding: 6px 0;\n}\n\n/* ---------------- menu (in <body>) ---------------- */\n.rf-bsw-menu {\n  position: fixed;\n  z-index: 80;\n  width: 260px;\n  max-width: calc(100vw - 16px);\n  max-height: min(420px, calc(100vh - 32px));\n  overflow-y: auto;\n  padding: 6px;\n  background: #fff;\n  border: 1px solid #e2dcd0;\n  border-radius: 12px;\n  box-shadow: 0 14px 40px rgba(40, 34, 22, 0.16);\n  font-family: \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: #191714;\n}\n.rf-bsw-menu-head {\n  padding: 6px 8px 8px;\n  font-size: 10.5px;\n  font-weight: 600;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: #a29b8d;\n}\n.rf-bsw-opt {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 7px 8px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  cursor: pointer;\n  font-family: inherit;\n  text-align: left;\n  color: inherit;\n}\n.rf-bsw-opt:hover:not(:disabled) {\n  background: var(--rf-brand-tint, #f6f0e2);\n}\n.rf-bsw-opt:disabled {\n  cursor: default;\n}\n.rf-bsw-opt.is-current .rf-bsw-name {\n  color: var(--rf-brand, #8c6a2c);\n}\n.rf-bsw-tick {\n  width: 14px;\n  flex-shrink: 0;\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--rf-brand, #8c6a2c);\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
